export default "__VITE_ASSET__3291a89d__"